import { render } from "./app-layout.vue?vue&type=template&id=3ac94d32"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__